import React, { Component } from 'react';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { Alert, Card } from '@betareader/design-system';

import { authUtil } from '../../utils';

export class Actions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const parsedQueryString = queryString.parse(location.search);
    const action = parsedQueryString.a;
    const userId = parsedQueryString.u;
    const list = parsedQueryString.l;
    if (action === 'unsubscribe') {
      this.unsubscribeFromList({ userId, list });
    }
  }

  unsubscribeFromList = async ({ userId, list }) => {
    const { t } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    this.setState({
      loading: true
    });
    await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/link-actions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'br-token': idToken
      },
      body: JSON.stringify({
        action: 'unsubscribe',
        userId,
        list
      })
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        throw new Error('Failed to unsubscribe. Email support@betareader.io if this continues.');
      })
      .then(() => {
        this.setState({
          confirmationStatus: true,
          confirmationMessage: t('UnsubscribeSuccessful')
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          confirmationStatus: false,
          confirmationMessage: t('UnsubscribeUnsuccessful')
        });
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  render() {
    const { loading, confirmationStatus, confirmationMessage } = this.state;
    return (
      <main style={{ margin: '2rem auto', maxWidth: 680, padding: '0 var(--br-space-4)' }}>
        <Card>
          {loading && <p role='status'>{this.props.t('Loading', 'Loading…')}</p>}
          {confirmationMessage && (
            <Alert variant={confirmationStatus ? 'success' : 'error'}>{confirmationMessage}</Alert>
          )}
        </Card>
      </main>
    );
  }
}

export default withTranslation()(Actions);
